export default {
    Metadata: {
        Name: "Abs",
        Description: "The absolute value of the given value.",
        Syntax: "Abs(number)",
        Keywords: ['Math'],
        Author: "DataVoke, Inc.",
    },
    execute(v) {
        return Math.abs(v);
    },
};

